import type { ReactNode } from "react";
import "./modal.css";
import { Button } from "../button";
import { Icon } from "../icon";

interface ConfirmModalProps {
  isOpen: boolean;
  title: string;
  message: ReactNode;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function ConfirmModal({
  isOpen,
  title,
  message,
  confirmText = "Supprimer",
  cancelText = "Annuler",
  onConfirm,
  onCancel,
}: ConfirmModalProps) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal">
        <div className="modal-header">
          <div className="modal-icon-warning-container">
            <Icon className="modal-icon-warning" name="warning"/>
          </div>
          <h2>{title}</h2>
        </div>
        <div className="modal-body">
          {message}
        </div>
        <div className="modal-footer">
            <Button 
                onClick={onCancel}
                variant="soft"
                label={cancelText}>
            </Button>
            <Button 
                onClick={onConfirm}
                variant="destructive"
                label={confirmText}>
            </Button>
        </div>
      </div>
    </div>
  );
}